//Create a roster for each team.
//Even while not logged in, you can see a list of players within the chosen team.
//This here is a page that OUTPUTS that list.
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Players.css'
import '../../shared/schedule/FullScheduleCards.css'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Footer from '../../shared/components/UIElements/Footer'
//import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import RosterAndScheduleHome from '../../shared/components/Navigation/RosterAndScheduleHome'

import FL from '../../images/FL.png'
import MA from '../../images/MA.png'
import MI from '../../images/MI.png'
import MN from '../../images/MN.png'
import NC from '../../images/NC.png'
import NH from '../../images/NH.png'
import NJ from '../../images/NJ.png'
import NY from '../../images/NY.png'
import PA from '../../images/PA.png'
import QC from '../../images/QC.png'
import PHX from '../../images/PHX.PNG'

const RosterAndSchedulePage = () => {
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [rosteredPlayers, setRosteredPlayers] = useState()
	const [gamesList, setGamesList] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamId, setTeamId] = useState()
	const [headCoach, setHeadCoach] = useState()
	const [assistantCoaches, setAssistantCoaches] = useState()
	const [generalManager, setGeneralManager] = useState()
	const [assistantGeneralManagers, setAssistantGeneralManagers] = useState()
	const [photo, setPhoto] = useState()
	//
	const leagueId = useParams().leagueId
	const divisionName = useParams().divisionName
	const year = useParams().year
	const teamName = useParams().teamName

	console.log('inside RosterAndSchedulePage.js')

	//taps into LEAGUE backend, getPlayersOnTeam.  There's also getPlayersOnTeam in admin backend, so be careful
	//Also returns wins, losses, OTlosses, and SOlosses
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/${leagueId}/${divisionName}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setRosteredPlayers(responseData.rosteredPlayers)
				setWins(responseData.wins)
				setPhoto(responseData.photo)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueName(responseData.leagueName)
				setHeadCoach(responseData.headCoach)
				setAssistantCoaches(responseData.assistantCoaches)
				setGeneralManager(responseData.generalManager)
				setAssistantGeneralManagers(responseData.assistantGeneralManagers)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [divisionName, teamName, year, leagueId])
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	const teamLogoMap = {
		Florida: FL,
		Massachusetts: MA,
		Minnesota: MN,
		Michigan: MI,
		'North Carolina': NC,
		'New Hampshire': NH,
		'New Jersey': NJ,
		'New Jersey 1': NJ,
		'New Jersey 2': NJ,
		'New York': NY,
		'Team Quebec': QC,
		'Team Quebec 1': QC,
		'Team Quebec 2': QC,
		Pennsylvania: PA,
		'Niagara Phoenix': PHX,
		'Ontario Phoenix': PHX,
	}
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		if (!game?.date) {
			return ''
		}

		return `${game.dayOfWeek || ''}, ${
			months[game.date.substr(0, 2)] || ''
		} ${game.date.substr(3, 2)}`.replace(/^,\s*/, '')
	}

	const formatGameTime = (game) => {
		if (!game?.time) {
			return ''
		}

		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour] || ''
	}
	//
	//
	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const leftScore = Number(scoreParts[0])
		const rightScore = Number(scoreParts[1])

		if (Number.isNaN(leftScore) || Number.isNaN(rightScore)) {
			return game.score
		}

		if (game.winner === game.homeTeamId) {
			const homeScore = Math.max(leftScore, rightScore)
			const visitorScore = Math.min(leftScore, rightScore)

			return `${homeScore} - ${visitorScore}`
		}

		if (game.winner === game.visitorTeamId) {
			const homeScore = Math.min(leftScore, rightScore)
			const visitorScore = Math.max(leftScore, rightScore)

			return `${homeScore} - ${visitorScore}`
		}

		return `${leftScore} - ${rightScore}`
	}
	//
	//
	//
	//
	//Send a request to get all the games for this team to display a schedule
	//leagueController - getTeamSchedule
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}/${divisionName}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					console.log('whoopsie daisy')
					throw new Error(responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setGamesList(responseData.allGamesArray)

				setTeamId(responseData.teamId)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [divisionName, teamName, year, leagueId])

	const getOpponent = (game) => {
		if (game.homeTeamName === teamName) {
			return {
				name: game.visitorTeamName,
				locationLabel: 'HOME',
			}
		}

		return {
			name: game.homeTeamName,
			locationLabel: 'AWAY',
		}
	}

	const getTeamResult = (game) => {
		if (!game.score) {
			return {
				label: '',
			}
		}

		if (!game.winner && !game.loser) {
			return {
				label: `TIED ${game.score}`,
			}
		}

		if (game.winner === teamId) {
			return {
				label: `WON ${game.score}`,
			}
		}

		if (game.loser === teamId) {
			return {
				label: `LOST ${game.score}`,
			}
		}

		return {
			label: game.score,
		}
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<RosterAndScheduleHome />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && rosteredPlayers && gamesList && (
					<React.Fragment>
						<div className='Roster' style={{ marginTop: '1rem' }}>
							<div className='rosterHeroMobile'>
								<h1>{teamName}</h1>

								<h3>
									{year} {divisionName}
								</h3>

								<div className='rosterHeroDivider'>
									<span></span>
									<div>★</div>
									<span></span>
								</div>

								{photo && (
									<img
										src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
										className='rosterHeroTeamPhoto'
										alt={teamName}
									/>
								)}
								<div className='rosterHeroDetails'>
									{headCoach && (
										<p>
											<strong>Head Coach:</strong> {headCoach}
										</p>
									)}

									{assistantCoaches && (
										<p>
											<strong>Assistant Coach(es):</strong> {assistantCoaches}
										</p>
									)}

									{generalManager && (
										<p>
											<strong>General Manager:</strong> {generalManager}
										</p>
									)}

									{assistantGeneralManagers && (
										<p>
											<strong>Assistant General Manager(s):</strong>{' '}
											{assistantGeneralManagers}
										</p>
									)}
								</div>

								<div className='rosterHeroRecord'>
									<span>Record:</span> {wins} - {losses} -{' '}
									{ties + overtimeLosses + shootoutLosses}
								</div>
							</div>

							<div className='rosterDesktopHeader'>
								<h1>{teamName}</h1>
								<h3 className='h3Center'>
									{year} {divisionName}
								</h3>

								{photo && (
									<div className='photoDiv'>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
											className='teamPhoto'
											alt={teamName}
										/>
									</div>
								)}
							</div>
							<div className='rosterDesktopDetails'>
								{headCoach && (
									<p
										className='clickOnATeamToSeeTheirRoster'
										style={{ textAlign: 'center', marginBottom: '0.5rem' }}
									>
										Head Coach: {headCoach}
									</p>
								)}
								{assistantCoaches && (
									<p
										className='clickOnATeamToSeeTheirRoster'
										style={{ textAlign: 'center', marginBottom: '0.5rem' }}
									>
										Assistant Coach(es): {assistantCoaches}
									</p>
								)}
								{generalManager && (
									<p
										className='clickOnATeamToSeeTheirRoster'
										style={{ textAlign: 'center', marginBottom: '0.5rem' }}
									>
										General Manager: {generalManager}
									</p>
								)}
								{assistantGeneralManagers && (
									<p
										className='clickOnATeamToSeeTheirRoster'
										style={{ textAlign: 'center', marginBottom: '0.5rem' }}
									>
										Assistant General Manager(s): {assistantGeneralManagers}
									</p>
								)}

								<h3 className='h3Center'>
									Record: {wins} - {losses} -{' '}
									{ties + overtimeLosses + shootoutLosses}
								</h3>
							</div>
							<p style={{ textAlign: 'center', fontSize: 'xx-small' }}>
								(PG: Playoff Goals | PA: Playoff Assists)
							</p>
							<table id='roster'>
								<thead>
									<tr>
										<th>Number</th>
										<th>Name</th>
										<th>G</th>
										<th>A</th>
										<th>PG</th>
										<th>PA</th>
										<th>GWG</th>
										<th>Total Pts.</th>
										<th>PIM</th>
									</tr>
								</thead>
								<tbody>
									{rosteredPlayers.map((player, key) => {
										{
											return (
												<tr key={key}>
													<td>{player.number}</td>
													<td className='tableDataTeamName'>
														<Link
															style={{
																textDecoration: 'none',
																color: 'black',
																fontWeight: 600,
															}}
															to={`/${player.playerId}/history`}
														>
															{player.firstName} {player.lastName}{' '}
															{player.isCaptain && '(Captain)'}{' '}
															{player.isGoalie && '(Goalie)'}
														</Link>
													</td>
													<td>{player.goals}</td>
													<td>{player.assists}</td>
													<td>{player.playoffGoals}</td>
													<td>{player.playoffAssists}</td>
													<td>{player.gwg}</td>
													<td>
														{player.goals +
															player.assists +
															player.playoffGoals +
															player.playoffAssists}
													</td>
													<td>{player.pim}</td>
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						</div>
						{/* THIS STARTS THE TEAMS SCHEDULE */}
						{/* THIS STARTS THE TEAM SCHEDULE */}
						<div className='Roster rosterAndScheduleSchedule'>
							<h1 className='rosterAndScheduleSchedule__title'>Schedule:</h1>

							{/* Existing desktop/tablet schedule */}
							<div className='rosterAndScheduleSchedule__desktop'>
								<table id='roster'>
									<thead>
										<tr>
											<th>Date/Time</th>
											<th>Opponent</th>
											<th>Score</th>
											<th>Venue</th>
										</tr>
									</thead>

									<tbody>
										{gamesList.map((game, key) => {
											const opponent = getOpponent(game)
											const result = getTeamResult(game)

											return (
												<tr key={game._id || key}>
													<td>
														{formatGameDate(game)}
														<br />
														{formatGameTime(game)}
													</td>

													<td>
														{opponent.locationLabel === 'AWAY' && '@ '}

														<Link
															style={{
																textDecoration: 'none',
																fontWeight: 600,
																color: 'black',
															}}
															to={`/league/${leagueId}/${divisionName}/${year}/${opponent.name}`}
														>
															{opponent.name}
														</Link>

														{game.description && (
															<div style={{ color: 'red', fontWeight: 'bold' }}>
																({game.description})
															</div>
														)}
													</td>

													<td>
														{game.score ? (
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color:
																		game.winner === teamId
																			? 'green'
																			: game.loser === teamId
																				? 'red'
																				: 'black',
																}}
																to={`/gameSummary/${game._id}`}
															>
																{result.label}
																{game.status === 'Shootout' && ' (SO)'}
																{game.scoreSuffix && ` ${game.scoreSuffix}`}
															</Link>
														) : (
															''
														)}
													</td>

													<td>{game.venueName}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>

							{/* Mobile schedule cards */}
							<div className='scheduleCardsMobile rosterAndScheduleSchedule__mobile'>
								{gamesList.map((game, key) => {
									const homeLogo = teamLogoMap[game.homeTeamName]
									const visitorLogo = teamLogoMap[game.visitorTeamName]

									return (
										<div
											className={`scheduleCard ${
												game.playoff || game.championship || game.description
													? 'scheduleCardPlayoff'
													: ''
											}`}
											key={game._id || `mobile-${key}`}
										>
											<div className='scheduleCard__header'>
												<div>{formatGameDate(game)}</div>

												<div className='scheduleCard__divisionHeader'>
													<div>
														{game.playoff
															? 'PLAYOFF'
															: game.divisionName || divisionName}
													</div>

													{game.playoff && game.description && (
														<span className='scheduleCard__headerDescription'>
															{game.playoffDivision} - {game.description}
														</span>
													)}

													{!game.playoff && game.description && (
														<span className='scheduleCard__headerDescription'>
															{game.description}
														</span>
													)}
												</div>

												<div>{formatGameTime(game)}</div>
											</div>

											<div className='scheduleCard__body'>
												<div className='scheduleCard__team'>
													{homeLogo && (
														<img
															src={homeLogo}
															alt={`${game.homeTeamName} logo`}
														/>
													)}

													<Link
														className={
															game.winner === game.homeTeamId
																? 'scheduleCard__winnerPill scheduleCard__teamLink'
																: 'scheduleCard__teamLink'
														}
														to={`/league/${leagueId}/${divisionName}/${year}/${game.homeTeamName}`}
													>
														{game.homeTeamName}
													</Link>
												</div>

												<div className='scheduleCard__scoreBox'>
													{game.score ? (
														<Link
															to={`/gameSummary/${game._id}`}
															className='scheduleCard__score'
														>
															{getDisplayScore(game)}
														</Link>
													) : (
														<div className='scheduleCard__score'>TBP</div>
													)}

													{game.score && (
														<div className='scheduleCard__status'>
															{game.status === 'Shootout'
																? 'SO'
																: game.status === 'Overtime'
																	? 'OT'
																	: 'FINAL'}
														</div>
													)}
												</div>

												<div className='scheduleCard__team'>
													{visitorLogo && (
														<img
															src={visitorLogo}
															alt={`${game.visitorTeamName} logo`}
														/>
													)}

													<Link
														className={
															game.winner === game.visitorTeamId
																? 'scheduleCard__winnerPill scheduleCard__teamLink'
																: 'scheduleCard__teamLink'
														}
														to={`/league/${leagueId}/${divisionName}/${year}/${game.visitorTeamName}`}
													>
														{game.visitorTeamName}
													</Link>
												</div>
											</div>

											{game.venueName && (
												<div className='scheduleCard__venue'>
													📍 {game.venueName}
												</div>
											)}

											{game.championship && (
												<div className='scheduleCard__description'>
													CHAMPIONSHIP GAME
												</div>
											)}
										</div>
									)
								})}
							</div>
						</div>
						{/* <div className='Roster'>
							<h1>Schedule:</h1>
							<table id='roster'>
								<thead>
									<tr>
										<th>Date/Time</th>
										<th>Opponent</th>
										<th>Score</th>
										<th>Venue</th>
									</tr>
								</thead>
								<tbody>
									{gamesList.map((game, key) => {
										{
											return (
												<tr key={key}>
													<td>
														{game.dayOfWeek}
														{', '}
														{game.date.substr(0, 2) === '01' &&
															'Jan ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '02' &&
															'Feb ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '03' &&
															'Mar ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '04' &&
															'Apr ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '05' &&
															'May ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '06' &&
															'June ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '07' &&
															'July ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '08' &&
															'Aug ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '09' &&
															'Sept ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '10' &&
															'Oct ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '11' &&
															'Nov ' + game.date.substr(3, 2)}
														{game.date.substr(0, 2) === '12' &&
															'Dec ' + game.date.substr(3, 2)}
														<br></br>
														{game.time.substr(0, 2) === '00' &&
															'12:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '01' &&
															'1:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '02' &&
															'2:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '03' &&
															'3:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '04' &&
															'4:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '05' &&
															'5:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '06' &&
															'6:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '07' &&
															'7:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '08' &&
															'8:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '09' &&
															'9:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '10' &&
															'10:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '11' &&
															'11:' + game.time.substr(3, 2) + ' am'}
														{game.time.substr(0, 2) === '12' &&
															'12:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '13' &&
															'1:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '14' &&
															'2:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '15' &&
															'3:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '16' &&
															'4:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '17' &&
															'5:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '18' &&
															'6:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '19' &&
															'7:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '20' &&
															'8:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '21' &&
															'9:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '22' &&
															'10:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '23' &&
															'11:' + game.time.substr(3, 2) + ' pm'}
														{game.time.substr(0, 2) === '24' &&
															'12:' + game.time.substr(3, 2) + ' am'}
													</td>
													{game.homeTeamName === teamName && (
														<td>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/league/${leagueId}/${divisionName}/${year}/${game.visitorTeamName}`}
															>
																{game.visitorTeamName}
															</Link>
															{game.description && (
																<div
																	style={{ color: 'red', fontWeight: 'bold' }}
																>
																	{'('}
																	{game.description}
																	{')'}
																</div>
															)}
														</td>
													)}
													{game.visitorTeamName === teamName && (
														<td>
															@{' '}
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/league/${leagueId}/${divisionName}/${year}/${game.homeTeamName}`}
															>
																{game.homeTeamName}
															</Link>
															{game.description && (
																<div
																	style={{ color: 'red', fontWeight: 'bold' }}
																>
																	{'('}
																	{game.description}
																	{')'}
																</div>
															)}
														</td>
													)}
													{!game.score && <td></td>}
													{game.score && !game.winner && !game.loser && (
														<td style={{ color: 'black', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/gameSummary/${game._id}`}
															>
																TIED {game.score}
															</Link>
														</td>
													)}
													{game.loser === teamId && (
														<td style={{ color: 'red', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'red',
																}}
																to={`/gameSummary/${game._id}`}
															>
																LOST {game.score}
																{game.status === 'Shootout' && ' (SO)'}{' '}
																<span
																	style={{ color: 'black', fontWeight: 'bold' }}
																>
																	{game.scoreSuffix}
																</span>
															</Link>
														</td>
													)}
													{game.winner === teamId && (
														<td style={{ color: 'green', fontWeight: 'bold' }}>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'green',
																}}
																to={`/gameSummary/${game._id}`}
															>
																WON {game.score}
																{game.status === 'Shootout' && ' (SO)'}{' '}
																<span
																	style={{ color: 'black', fontWeight: 'bold' }}
																>
																	{game.scoreSuffix}
																</span>
															</Link>
														</td>
													)}
													<td>{game.venueName}</td>
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						</div> */}
						<Footer />
					</React.Fragment>
				)}
			</React.Fragment>
		</div>
	)
}

export default RosterAndSchedulePage
